export default function install(Vue, options) {
  var vm = new Vue({
    data: {
      loading: false
    }
  });

  Object.defineProperties(Vue.prototype, {
    $loading: {
      get: function() {
        return vm.loading;
      },
      set: function(value) {
        vm.loading = value;
        return this;
      }
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/loading.js
// module id = null
// module chunks = 